import useMutationApi from 'src/api/useMutationApi';

interface TriggerRefetchAllDataResponse {
  message: string;
  timestamp: string;
}

export function useTriggerRefetchAllData(
  onSuccess?: () => void,
  onError?: (error: Error) => void,
) {
  return useMutationApi<void, TriggerRefetchAllDataResponse>({
    endpoint: 'core/trigger-refetch-all-data',
    method: 'POST',
    showSuccessToast: true,
    successMessage: 'Data pull triggered successfully',
    showErrorToast: false, // Disable generic error toast
    options: {
      onSuccess,
      onError: (error) => {
        onError?.(error);
      },
    },
  });
}
